export default __webpack_public_path__ + "static/media/locationPhone.2ff3b085.svg";